import React, {useCallback, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import useCancelToken from '../../../../../../../_gori/hooks/UseCancelToken'
import {Button, ButtonBack} from '../../../../../../../_gori/partials/widgets'
import {OrderType} from '../../../../../orders/core/_const'
import SettingsService from '../../../../core/_requests'
import {StoresListing} from '../StoresListing'

import {PromotionBanner, BannerContent} from '../../../../../common/components/PromotionBanner'
import {usePromoEligibility} from '../../../../../../../_gori/hooks/UsePromoEligibility'
import {ConnectionLink} from '../ConnectionLink'
import {KTSVG} from '../../../../../../../_gori/helpers'
import {useNavigate} from 'react-router-dom'

const ConnectTikTok: React.FC = () => {
  const intl = useIntl()
  const {isCancel, newCancelToken} = useCancelToken()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [configs, setConfigs] = useState<any>(null)
  const {getMarketPromoStatus} = usePromoEligibility()
  const tiktokPromoStatus = getMarketPromoStatus('tiktok')
  const isPromoEligible = tiktokPromoStatus.isEligible
  const isPromoApplied = tiktokPromoStatus.isApplied
  const navigate = useNavigate()

  const getConfig = useCallback(async () => {
    setIsLoading(true)
    const config = {
      params: {
        config_name: OrderType.TIKTOK,
      },
      cancelToken: newCancelToken(),
    }

    try {
      const {configurations} = await SettingsService.getConfig(config)
      setConfigs(configurations)
    } catch (error) {
      if (isCancel(error)) return
    } finally {
      setIsLoading(false)
    }
  }, [isCancel, newCancelToken])

  useEffect(() => {
    getConfig()
  }, [getConfig])

  const tiktokBannerContent: Partial<BannerContent> = {
    helpLinkTo: '/help-center/store-connection/tiktok',
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='store-connect-page'>
          <div className='store-connect-page__header'>
            <div className='store-connect-page__header-main'>
              <div className='d-flex align-items-center store-connect-page__back'>
                <ButtonBack className='store-connect-page__back-button me-0' />
                <button
                  type='button'
                  className='store-connect-page__back-arrow'
                  aria-label='Go back'
                  onClick={() => navigate(-1)}
                >
                  <KTSVG path='/media/gori/left_arrow.svg' />
                </button>
              </div>
              <div className='d-flex flex-column'>
                <div className='d-flex gap-4 align-items-center flex-wrap'>
                  <span className='store-connect-page__title fw-bolder text-dark fs-3'>
                    {intl.formatMessage({id: 'CONNECT_TO'})} TikTok
                  </span>
                </div>
                <ConnectionLink url={tiktokBannerContent.helpLinkTo || ''} />
              </div>
            </div>
            {isPromoApplied && (
              <PromotionBanner
                isEligible={isPromoEligible}
                isApplied={isPromoApplied}
                content={tiktokBannerContent}
              />
            )}
          </div>

          <div className='store-connect-page__body'>
            <div className='store-connect-page__form-card store-connect-page__form-card--stacked'>
              <div className='store-connect-page__form-connect-bar'>
                <p className='store-connect-page__form-connect-notice'>
                  {intl.formatMessage({id: 'STORE_CONNECTION_MARKETPLACE_REDIRECT_NOTICE'})}
                </p>
                <Button
                  className='btn btn-advanced-primary store-connect-page__form-stack-connect'
                  loading={isLoading}
                  loadingText={intl.formatMessage({id: 'CONNECT'})}
                  label={intl.formatMessage({id: 'CONNECT'})}
                  event={() => {
                    const url = `https://services.tiktokshops.us/open/authorize?service_id=${configs?.TIKTOK_APP_ID}`
                    window.location.replace(url)
                  }}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className='store-connect-page__stores'>
              <StoresListing storeType={OrderType.TIKTOK} />
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  )
}

export {ConnectTikTok}
